import { createSlice } from '@reduxjs/toolkit';
// "parcel": { "height": 1, "width": 5, "depth": 5, "weight": 1, "product_value": 0 }
const initialState = {
  parcelData: {
    fields: {
      name: '',
      product_description: '',
      height: '',
      width: '',
      depth: '',
      weight: '',
      product_value: '', // this value is sent int the request
      insurance: false,
      multiPieces: 1,
      products: [], // e-commerce products
      orderPluginId: '', // e-commerce order id
    },
    errors: {
      name: false,
      product_description: false,
      height: false,
      width: false,
      depth: false,
      weight: false,
      product_value: false,
      insurance: false,
      products: false,
    },
    valid: {
      name: false,
      product_description: false,
      height: false,
      width: false,
      depth: false,
      weight: false,
      insurance: false,
    },
  },
};

const parcelDataSlice = createSlice({
  name: 'parcelData',
  initialState,
  reducers: {
    setParcelData(state, action) {
      const { point, data } = action.payload;
      state.parcelData.fields[point] = data;
    },
    setParcelDataError(state, action) {
      const { point, data } = action.payload;
      state.parcelData.errors[point] = data;
    },
    setParcelDataValidate(state, action) {
      const { point, data } = action.payload;
      state.parcelData.valid[point] = data;
    },
    clearParcelForm: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = initialState[key];
      });
    },
  },
});
export const { setParcelData, setParcelDataError, setParcelDataValidate, clearParcelForm } = parcelDataSlice.actions; // imported in enviar.js
const ParcelDataReducer = parcelDataSlice.reducer; // store.js set up

export default ParcelDataReducer;
